import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMars, faVenus, faNeuter } from '@fortawesome/free-solid-svg-icons';

export const GenderIcon = ({ gender, size, withColor = false }: {
    gender: string,
    size?: "lg" | "2x" | "3x" | "4x" | "5x" | "sm",
    withColor?: boolean
}) => {
    let icon = faNeuter;
    if (gender === "male") {
        icon = faMars
    } else if (gender === "female") {
        icon = faVenus
    }
    return <span className={`gender-text ${withColor ? gender : ''}`}>
        <FontAwesomeIcon icon={icon} size={size} />
    </span>
}

export const GenderButton = ({ gender, onChange }: { gender: string, onChange?: () => void }) => {

    return (
        <div id='gender-btn' onClick={() => onChange?.()} className={`gender-btn my-auto button ${gender}`}>
            <GenderIcon gender={gender} />
        </div>
    )
}
